<script>
    export let sobremesas;
</script>

<style>
    .sobremesas {
        border-top: 1px solid #eee;
        padding-top: 50px;
        padding-bottom: 50px;
        font-family: "Poppins", sans-serif;
    }

    .sobremesas p {
        color: #f42f2c;
        font-size: 14px;
        font-weight: 300;
    }

    .sobremesas b {
        font-weight: 700;
    }

    .title h1 {
        font-weight: 600;
        padding-bottom: 40px;
    }

    @media (max-width: 991.98px) {
        .title h1 {
            font-size: 30px !important;
            font-weight: 600;
            padding-bottom: 40px;
        }
    }
</style>

<main>
    <div class="sobremesas">
        {#if sobremesas != null }
        <div class="title text-center">
            <h1>{sobremesas.categoria}</h1>
        </div>
        
        <div class="feature-section">
            <center>
                {#each sobremesas.tipos as sobremesa}
                    <p><b>{sobremesa.nome}:</b> {sobremesa.descricao}</p>
                {/each}
            </center>
        </div>
        {/if}
    </div>
</main>
